import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { handleDownloadDocument } from '../../../CommonMethhods/CommonMethods';
import { PARTNER } from '../../../Configuration/Partner_URL';
import { decryptData, encryptData } from "../../../CommonMethhods/CommonMethods";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { axiosSsoJson, axiosSsoText } from '../../../CommonMethhods/axiosPartnerInterceptor';


function PartnerDocumentDetailsPreview(props) {
    const storeToken = localStorage.getItem("ssoToken");
    let partnerID = localStorage.getItem("PartnerId")
    let navigate = useNavigate();
    let partnerDetails = props.partnerDetails
    const [showModal, setShowModal] = useState(false)
    const [rejectionData, setRejectionData] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([]);

    const onHide = () => {
        setShowModal(false);
        setSelectedFiles([])
    };
    const getRejectionReason = async () => {
        try {
            const getRejection = await axiosSsoJson.get(
                PARTNER.REJECT_REASONS,
            );
            const data = decryptData(getRejection.data)
            let dataResp = JSON.parse(data)
            if (dataResp) {
                setRejectionData(dataResp.data.rejectReasons)
            }

        } catch (error) {
            console.log(error);
        }
    };
    const rejectedUpdated = async () => {
        let req = {
            id: parseInt(partnerID),
            status: -2,
            reason: selectedFiles
        }
        let reqPay = encryptData(JSON.stringify(req))
        console.log(req, "reqPay");
        
        try {
            const getStatus = await axiosSsoText.put(
                PARTNER.REJECTION_UPDATED,
                reqPay,
            );
            const rejectResp = decryptData(getStatus.data)
            let respData = JSON.parse(rejectResp)
            if (respData.status === 0) {
                toast.success(respData.message)
                setShowModal(false)
                navigate("/application-review")
            }
            else {
                setShowModal(true)
            }

        } catch (error) {
            console.log(error);
        }
    };
    const approvedStatus = async () => {
        let approReq = {
            id: parseInt(partnerID),
            status: 2,

        }
        let payloadApproved = encryptData(JSON.stringify(approReq))
        try {
            const getStatus = await axiosSsoText.put(
                PARTNER.REJECTION_UPDATED,
                payloadApproved,
            );
            const dataResp = decryptData(getStatus.data)
            let respParse = JSON.parse(dataResp)
            if (respParse.status === 0) {
                navigate("/application-review")
                toast.success(respParse.message)
            }
        } catch (error) {
            console.log(error);
        }
    };
    const downloadMultiple = (checked = true) => {
        const selectDownload = document.querySelectorAll(".downloadSelect");
        let selectArray = [];
        for (let item of selectDownload) {
            if (checked) {
                if (item.checked === true) {
                    selectArray.push(parseInt(item.value));
                }
            } else {
                selectArray.push(item.value);
            }
        }
        setSelectedFiles(selectArray);
    };
    const getReason = () => {
        downloadMultiple()
    }
    useEffect(() => {
        getRejectionReason()
        setSelectedFiles([])
    }, []);


    return (
        <>
            <div className="card-box">
                <div className='card-title'>
                    <h2 className="">
                        Documents
                    </h2>
                </div>

                <div className="">
                    <div className="">
                        <div className="imgWrapper row">
                            {partnerDetails &&
                                partnerDetails?.files?.map((item) => {
                                    return (
                                        <>
                                            <div key={item?.id} className='col-md-6 bottom-25 documents-grid'>
                                                <p className='pdf-label'>
                                                    {item?.type == "1" ? "PAN CARD" : item?.type == "2" ? "ADDRESS CARD (FRONT)" : item?.type == "3" ? "ADDRESS CARD (BACK)" : item?.type == "4" ? "BANK PROOF" : item?.type == "5" ? "PHOTO" : item?.type == "6" ? "Agreement" : null}</p>
                                                <div className='document-wrapper'>
                                                    
                                                    {item?.fileName?.split(".")[1] === 'pdf' ? (
                                                        <div
                                                            style={{
                                                                height: '197px',
                                                                width: '230px',
                                                                overflow: 'auto',
                                                            }}
                                                        >
                                                            <div>
                                                                {
                                                                    <Worker workerUrl="/pdf.worker.min.js">
                                                                        <Viewer fileUrl={item?.s3Url} />
                                                                    </Worker>
                                                                }
                                                            </div>
                                                        </div>
                                                        // <iframe src={item?.s3Url} className="document-pdf partner-down" sandbox>
                                                        // </iframe>
                                                    )
                                                        :
                                                        (
                                                            <img src={item?.s3Url} className='document-img' alt='document-img' />
                                                        )
                                                    }
                                                    <span className="icon-download" onClick={() => { handleDownloadDocument(item?.s3Url) }}></span>
                                                    {/* <img src={download} alt="" className="download-img partner-down"  /> */}
                                                </div>
                                            </div>
                                        </>
                                    );
                                })}
                        </div>
                    </div>
                </div>
                {partnerDetails.statusId === 2 || partnerDetails.statusId === -3 || partnerDetails.statusId === -2 || partnerDetails.statusId === 3 || partnerDetails.statusId === 0 ?
                    <div>
                        <button className="back-btn" type="submit" onClick={() => { navigate("/application-review") }}>Back</button>
                    </div>
                    : partnerDetails.statusId === 1 ?
                        <div className="partner-btn">
                            <div><button className="appro-btn" type="submit" onClick={() => approvedStatus()}>Approve</button></div>
                            <div><button className="rej-btn" type="submit" onClick={() => setShowModal(true)}>Reject</button></div>
                            <div><button className="back-btn" type="submit" onClick={() => { navigate("/application-review") }}>Back</button></div>
                        </div>
                        : null
                }
            </div>
            <Modal
                show={showModal}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="setting-model partner-modal-rejection"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className="model-title">
                            Rejection Selection
                        </h2>
                    </Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={onHide}>
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <ul className="partner-ul">
                        {rejectionData &&
                            rejectionData?.map((item) => {
                                return (
                                        <li>
                                            <input type="checkbox" id="resons" value={item.id} className="downloadSelect" onClick={() => getReason()} />
                                            <label >{item.reason}</label>
                                        </li>
                                    );

                            })}
                        {/* </select> */}
                    </ul>
                    <button
                        type="submit"
                        className={selectedFiles.length ? "rej-btn " : "disabled-file"}
                        disabled={selectedFiles.length ? false : true}
                        onClick={() => rejectedUpdated()}

                    >Submit</button>
                </Modal.Body>


            </Modal>
        </>
    )
}

export default PartnerDocumentDetailsPreview;